module.exports = {
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'recordController'
	],

	config: {
		entityContext: 'trip',
		privilegeBase: 'artcrm_trips'
	}
}